import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Buildings.es.js";
const i = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...e, weights: t }));
i.displayName = "BuildingsIcon";
const m = i;
export {
  m as Buildings,
  i as BuildingsIcon
};
